export * from './panel-settings-messaging-email-templates.descriptor';
export * from './panel-settings-messaging-email-templates-form.descriptor';
export * from './panel-settings-messaging-message-templates-form.descriptor';
export * from './panel-settings-messaging-message-templates.descriptor';
